// @flow

// consts
import baseColors from './consts/baseColors';
import bps from './consts/bps';
import cssReset from './consts/cssReset';
import globalAds from './consts/globalAds';
import fontStacks from './consts/fontStacks';

// methods
import getColor from './methods/getColor';
import mq from './methods/mq';
import pxToRem from './methods/pxToRem';
import typesetter from './methods/typesetter';

import hdcTheme from './hdcTheme';
import type { CardStyle, } from './consts/cardStyle';

export default hdcTheme;
export {
  hdcTheme,
  cssReset,
  globalAds,
  baseColors,
  bps,
  fontStacks,
  getColor,
  mq,
  pxToRem,
  typesetter,
};

export type { CardStyle, };
